/** @format */

import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import InputIcon from 'react-multi-date-picker/components/input_icon';
import DatePicker from 'react-multi-date-picker';
import 'react-multi-date-picker/styles/backgrounds/bg-dark.css';
import { toJalaliPickerValue } from '../../../Shared/utils/helper';

const DatePic = ({ field, onChangeValue, teamForm }) => {
	const pickerValue = toJalaliPickerValue(field?.value);

	return (
		<>
			<div className='form-group d-flex flex-column'>
				<label>{field.label}</label>
				<DatePicker
					render={<InputIcon />}
					calendar={persian}
					value={pickerValue === '' ? '' : pickerValue}
					locale={persian_fa}
					minDate={new Date().setFullYear(1921)}
					className=''
					portal
					format='YYYY/MM/DD'
					onChange={(date) => {
						const picked = Array.isArray(date) ? date[0] : date;
						if (
							!picked ||
							picked.year == null ||
							picked.month == null ||
							picked.day == null
						) {
							onChangeValue(field.name, '', teamForm);
							return;
						}
						const month =
							typeof picked.month === 'object'
								? picked.month.number
								: picked.month;
						onChangeValue(
							field.name,
							`${picked.year}/${String(month).padStart(2, '0')}/${String(picked.day).padStart(2, '0')}`,
							teamForm,
						);
					}}
				/>
			</div>
		</>
	);
};

export default DatePic;
